import { Application } from 'application/Shared/types/application';
import { TenantApp } from 'application/Shared/types/tenantApp';

/**
 * Groups applications by their subcategory and returns the top 6 categories by application count.
 * Applications without a subcategory are filtered out.
 *
 * @param data - Array of Application or TenantApp objects
 * @returns Array of grouped applications sorted by count (descending), limited to top 6
 */
export function groupApplicationsBySubcategory({
    data
}: {
    data: Application[] | TenantApp[];
}) {
    const grouped: Record<string, Application[]> = data.reduce(
        (acc, application) => {
            const app = (application as TenantApp).application || application;
            const subcategory = application.subCategory;

            if (
                !subcategory ||
                subcategory === 'Other' ||
                subcategory === 'Unknown'
            ) {
                return acc;
            }

            if (!acc[subcategory]) {
                acc[subcategory] = [];
            }

            acc[subcategory].push(app);

            return acc;
        },
        {} as Record<string, Application[]>
    );

    return Object.entries(grouped)
        .map(([subcategory, applications]) => ({
            applications,
            count: applications.length,
            // id is required by the table v2
            id: subcategory,
            name: subcategory,
            subcategory
        }))
        .sort((a, b) => b.applications.length - a.applications.length);
}
